import * as actionTypes from './actionTypes';

export const updateSmasterBalance=(data)=>{
   return {
      type:actionTypes.UPDATE_SMASTER_BALANCE,
      payload:data
   }
}